// Login.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { app } from '../FirebaseConfig'
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import './Login.css';

const auth = getAuth(app)
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    // Implement your login logic here
    console.log('Username:', username);
    console.log('Password:', password);
    signInWithEmailAndPassword(auth, username, password)
    .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log(user)
        navigate('/')
    })
    .catch((error) => {
        const errorMessage = error.message;
        alert(errorMessage)
    });
  };

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">Login</button>
      </form>
      <Link to="/forgot-password" className="forgot-password-link">Forgot Password?</Link>
      <button onClick={handleSignUp} className="signup-button">Sign Up</button>
    </div>
  );
};

export default Login;
